import React from 'react';
import classNames from 'classnames/bind';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { Button, Text } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var HeaderSearch = function HeaderSearch(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('search-header'),
    "data-t-id": "blocks-HeaderSearch"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert",
    size: "l"
  }, title), /*#__PURE__*/React.createElement(Button, {
    className: cx('search-header__button'),
    iconLeft: IconCloseRoundStroked,
    onClick: onClick,
    onlyIcon: true,
    size: "m",
    view: "tertiary"
  }));
};